import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { Category, getEmptyCategory } from '../../interfaces/Category/Category';
import { getCategories } from '../../api/Category';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { CategoryTree } from './CategoryTree';
import { ModifyCategorySection } from './ModifyCategorySection';

export const CategoriesPage = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<
    Category | undefined
  >(undefined);
  const [loading, setLoading] = useState(false);

  const refreshCategories = (selectedCategoryID?: number) => {
    setLoading(true);
    getCategories()
      .then((c) => {
        setCategories(c);
        if (selectedCategoryID) {
          setSelectedCategory(
            c.find((category) => category.id === selectedCategoryID),
          );
        }
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(refreshCategories, []);

  const handleAddRoot = () => {
    setSelectedCategory(getEmptyCategory());
  };

  const handleAddChild = (parentID: number) => {
    setSelectedCategory({ ...getEmptyCategory(), parentID });
  };

  const handleDelete = () => {
    setSelectedCategory(undefined);
    refreshCategories();
  };

  const handleSelect = (id: number) => {
    setSelectedCategory(categories.find((c) => c.id === id));
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Kategoriler
      </Typography>
      <Waiting open={loading} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 1.5,
        }}
      >
        <CategoryTree
          key={categories.length}
          selectedCategory={selectedCategory}
          categories={categories}
          onAddRoot={handleAddRoot}
          onAddChild={handleAddChild}
          onDelete={handleDelete}
          onSelect={handleSelect}
        />
        {selectedCategory && (
          <ModifyCategorySection
            category={selectedCategory}
            categories={categories}
            onCancel={() => setSelectedCategory(undefined)}
            onModify={refreshCategories}
          />
        )}
      </Box>
    </Box>
  );
};
